
export class FuelCardDisplayUtils {

    public static shouldDisplayDriverCashAdvanceIcon(cardStatus: string, hasValidIfuelUser: boolean): boolean {
        return cardStatus === "A" && hasValidIfuelUser != null && hasValidIfuelUser && hasValidIfuelUser === true;
    }

}
